module.exports = __webpack_public_path__ + "static/img/default_person_selected.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/default_person_selected.png
// module id = 548
// module chunks = 0